// extracted by mini-css-extract-plugin
module.exports = {"PointWrapper":"Points_PointWrapper__6v4cs"};